var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMysql(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with ImageTracer.java version 1.1.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 0",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 0.0 L 98.0 0.5 L 81.5 3.0 L 71.5 5.0 Q 56.0 9.0 47.0 19.5 L 45.0 23.5 L 44.0 31.5 L 44.0 49.5 L 44.0 121.5 Q 46.3 128.3 51.5 132.0 L 69.5 141.0 Q 77.8 144.7 89.5 145.0 L 101.0 146.5 L 123.5 147.0 L 128.5 146.0 L 146.0 143.5 Q 166.5 140.0 178.0 127.5 L 180.0 123.5 L 181.0 115.5 L 181.0 97.5 L 181.0 25.5 Q 178.8 18.8 173.5 15.0 Q 164.0 7.5 150.0 4.5 L 139.5 2.0 L 127.0 0.5 L 224.5 0.0 L 225.0 224.5 L 61.5 225.0 L 64.0 221.5 L 78.0 193.5 L 81.5 186.0 Q 83.9 183.9 83.0 178.5 Q 82.0 175.0 76.5 176.0 Q 70.6 180.6 68.5 189.0 Q 66.4 180.6 60.5 176.0 Q 55.0 175.0 54.0 178.5 Q 53.0 184.5 56.0 186.5 L 63.0 200.5 L 56.0 213.5 Q 53.2 216.2 54.0 222.5 L 55.5 225.0 L 0.0 224.5 L 0.5 0.0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 0",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 0.0 L 103.0 0.5 L 98.5 1.0 L 98.5 0.0 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 0",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 0.0 L 106.0 0.5 L 103.5 1.0 L 103.5 0.0 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 0",
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 0.0 L 135.5 2.0 L 154.5 6.0 Q 169.5 10.0 178.0 20.5 L 180.0 26.5 L 181.0 34.5 L 181.0 51.5 L 181.0 118.5 Q 179.0 128.5 171.5 133.0 Q 159.2 141.7 140.5 144.0 L 130.0 145.5 L 121.5 146.0 L 95.5 146.0 L 75.5 142.0 Q 56.8 138.7 47.0 126.5 L 44.5 119.0 L 44.0 113.5 L 44.0 96.5 L 44.0 28.5 Q 46.0 18.5 53.5 14.0 Q 65.3 5.8 82.5 3.0 L 99.5 1.0 Q 105.0 2.5 106.5 0.0 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 1",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 0.0 L 122.0 0.5 L 117.5 1.0 L 117.5 0.0 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 1",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 0.0 L 127.0 0.5 L 122.5 1.0 L 122.5 0.0 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 2",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 1.0 L 136.0 1.5 L 133.5 2.0 L 133.5 1.0 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 2",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 9.0 L 118.0 9.5 L 107.5 10.0 L 107.5 9.0 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 3",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 10.0 L 99.0 10.5 L 95.5 11.0 L 95.5 10.0 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 1",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 10.0 L 126.0 10.5 L 133.5 11.0 L 151.5 15.0 Q 163.1 17.9 170.0 25.5 L 171.0 31.5 Q 159.1 45.1 135.5 47.0 L 122.0 48.5 L 103.5 49.0 L 100.5 48.0 L 94.5 48.0 L 77.0 44.5 L 65.5 40.0 Q 57.6 37.9 54.0 31.5 Q 53.1 23.6 58.5 22.0 Q 69.7 14.2 86.5 12.0 L 94.5 11.0 L 99.5 10.0 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 4",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 10.0 L 130.0 10.5 L 126.5 11.0 L 126.5 10.0 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 5",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 14.0 L 51.5 16.0 L 52.5 14.0 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 6",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 15.0 L 174.5 17.0 L 173.5 15.0 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 3",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 16.0 L 48.5 19.0 L 50.5 16.0 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 7",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 18.0 L 177.5 20.0 L 176.5 18.0 Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 8",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 21.0 L 166.5 23.0 L 165.5 21.0 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 9",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 33.0 L 57.5 36.0 L 55.5 33.0 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 10",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 33.0 L 167.5 36.0 L 169.5 33.0 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 4",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 45.0 L 54.0 58.5 L 53.0 58.5 L 53.5 45.0 Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 5",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 45.0 L 172.0 58.5 L 171.0 58.5 L 171.5 45.0 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 2",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 46.0 Q 68.1 54.9 88.5 57.0 L 101.0 58.5 L 122.5 59.0 L 127.5 58.0 L 143.5 56.0 Q 159.3 53.3 170.5 46.0 L 171.0 60.5 L 166.5 66.0 L 152.0 72.5 L 134.5 77.0 L 127.0 77.5 L 98.5 78.0 L 78.5 74.0 Q 63.4 71.6 55.0 62.5 L 54.0 56.5 L 54.5 46.0 Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 11",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 47.0 L 135.0 47.5 L 132.5 48.0 L 132.5 47.0 Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 12",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 48.0 L 103.0 48.5 L 99.5 49.0 L 99.5 48.0 Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 13",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 48.0 L 127.0 48.5 L 122.5 49.0 L 122.5 48.0 Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 14",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 57.0 L 133.0 57.5 L 130.5 58.0 L 130.5 57.0 Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 15",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 58.0 L 107.0 58.5 L 101.5 59.0 L 101.5 58.0 Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 6",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 58.0 L 116.0 58.5 L 107.5 59.0 L 107.5 58.0 Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 16",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 58.0 L 123.0 58.5 L 116.5 59.0 L 116.5 58.0 Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 7",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 74.0 L 55.0 74.5 L 54.0 78.5 L 53.5 88.0 L 53.5 74.0 Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 8",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 74.0 L 172.0 74.5 L 171.5 88.0 L 171.0 79.5 L 170.5 74.0 Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 3",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 75.0 L 69.5 82.0 L 86.5 86.0 L 97.0 87.5 L 126.5 88.0 L 131.5 87.0 L 141.5 86.0 L 153.5 83.0 L 170.5 75.0 L 171.0 89.5 L 165.5 96.0 Q 150.1 105.6 126.5 107.0 L 95.5 107.0 L 78.0 103.5 L 64.5 99.0 L 55.0 91.5 L 54.0 85.5 L 54.5 75.0 Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 17",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 77.0 L 98.0 77.5 L 95.5 78.0 L 95.5 77.0 Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 18",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 77.0 L 130.0 77.5 L 127.5 78.0 L 127.5 77.0 Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 9",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 78.0 L 119.0 78.5 L 106.5 79.0 L 106.5 78.0 Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 19",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 86.0 L 136.0 86.5 L 133.5 87.0 L 133.5 86.0 Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 20",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 87.0 L 101.0 87.5 L 97.5 88.0 L 97.5 87.0 Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 10",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 87.0 L 105.0 87.5 L 101.5 88.0 L 101.5 87.0 Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 11",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 87.0 L 124.0 87.5 L 121.5 88.0 L 121.5 87.0 Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 21",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 87.0 L 127.0 87.5 L 124.5 88.0 L 124.5 87.0 Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 12",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 92.0 L 57.5 95.0 L 55.5 92.0 Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 13",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 92.0 L 167.5 95.0 L 169.5 92.0 Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 14",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 104.0 L 54.0 117.5 L 53.0 117.5 L 53.5 104.0 Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 4",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 104.0 Q 69.1 114.9 93.5 116.0 Q 95.0 118.5 100.5 117.0 L 116.5 118.0 Q 118.0 115.5 123.5 117.0 L 141.5 115.0 Q 159.3 112.8 170.5 104.0 L 171.0 119.5 L 167.5 124.0 Q 160.5 130.0 149.5 132.0 L 132.5 136.0 L 103.5 137.0 Q 102.3 134.8 97.5 136.0 L 82.5 134.0 L 70.5 131.0 Q 60.9 128.1 55.0 121.5 L 54.0 115.5 L 54.5 104.0 Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 15",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 104.0 L 172.0 117.5 L 171.0 117.5 L 171.5 104.0 Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 22",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 106.0 L 95.0 106.5 L 92.5 107.0 L 92.5 106.0 Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 23",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 106.0 L 133.0 106.5 L 130.5 107.0 L 130.5 106.0 Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 16",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 107.0 L 103.0 107.5 L 100.5 108.0 L 100.5 107.0 Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 24",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 107.0 L 122.0 107.5 L 103.5 108.0 L 103.5 107.0 Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 17",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 107.0 L 126.0 107.5 L 122.5 108.0 L 122.5 107.0 Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 18",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 116.0 L 99.0 116.5 L 96.5 117.0 L 96.5 116.0 Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 19",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 116.0 L 128.0 116.5 L 125.5 117.0 L 125.5 116.0 Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 25",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 116.0 L 131.0 116.5 L 128.5 117.0 L 128.5 116.0 Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 26",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 117.0 L 117.0 117.5 L 107.5 118.0 L 107.5 117.0 Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 27",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 124.0 L 165.5 126.0 L 166.5 124.0 Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 28",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 127.0 L 48.5 129.0 L 47.5 127.0 Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 29",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 127.0 L 173.5 132.0 L 177.5 127.0 Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 30",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 130.0 L 51.5 132.0 L 50.5 130.0 Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 20",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 136.0 L 99.0 136.5 L 96.5 137.0 L 96.5 136.0 Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 31",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 136.0 L 103.0 136.5 L 99.5 137.0 L 99.5 136.0 Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 32",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 136.0 L 127.0 136.5 L 123.5 137.0 L 123.5 136.0 Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 33",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 145.0 L 94.0 145.5 L 91.5 146.0 L 91.5 145.0 Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 34",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 145.0 L 134.0 145.5 L 131.5 146.0 L 131.5 145.0 Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 35",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 146.0 L 107.0 146.5 L 101.5 147.0 L 101.5 146.0 Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 21",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 146.0 L 117.0 146.5 L 107.5 147.0 L 107.5 146.0 Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 36",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 146.0 L 124.0 146.5 L 117.5 147.0 L 117.5 146.0 Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 37",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 156.0 L 115.0 156.5 L 110.5 157.0 L 110.5 156.0 Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 38",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 156.0 L 168.0 156.5 L 155.5 157.0 L 155.5 156.0 Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 39",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 156.0 L 197.0 156.5 L 194.5 157.0 L 194.5 156.0 Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 1",
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 7.5 157.0 L 12.5 158.0 L 16.0 161.5 L 24.5 173.0 L 37.5 157.0 L 43.0 158.5 Q 45.7 162.3 44.0 170.5 L 44.0 201.5 L 42.5 204.0 L 37.5 205.0 Q 33.3 203.3 35.0 195.5 L 34.5 176.0 L 33.0 176.5 L 26.5 185.0 L 21.5 184.0 L 18.0 180.5 L 14.5 176.0 L 14.0 195.5 Q 15.8 203.3 11.5 205.0 Q 7.0 206.0 6.0 203.5 Q 3.3 199.7 5.0 191.5 L 5.0 160.5 L 7.5 157.0 Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 22",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 157.0 L 35.5 159.0 L 36.5 157.0 Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 2",
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 157.0 Q 115.7 155.3 119.5 158.0 Q 126.9 159.1 130.0 164.5 L 132.0 171.5 L 130.5 174.0 L 125.5 175.0 L 120.5 168.0 Q 116.8 164.7 108.5 166.0 L 102.0 170.5 L 105.5 175.0 L 118.5 178.0 Q 127.5 179.0 131.0 185.5 L 132.0 192.5 Q 130.8 198.3 126.5 201.0 L 119.5 204.0 Q 115.7 206.7 107.5 205.0 Q 99.2 203.3 95.0 197.5 L 93.0 190.5 L 95.5 187.0 Q 101.0 186.0 102.0 189.5 L 104.5 194.0 Q 108.2 197.3 116.5 196.0 L 122.0 192.5 L 123.0 190.5 Q 120.3 185.7 113.0 185.5 L 111.5 181.0 L 110.5 185.0 Q 98.7 184.3 94.0 176.5 L 93.0 169.5 Q 94.5 163.0 99.5 160.0 L 107.5 157.0 Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 3",
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 157.0 L 165.5 157.0 Q 170.3 155.8 171.5 158.0 L 178.0 162.5 L 180.5 170.0 L 181.0 175.5 L 181.0 191.5 L 179.0 197.5 L 181.0 200.5 L 179.5 204.0 L 174.5 205.0 L 170.5 204.0 L 165.5 205.0 L 152.5 205.0 L 144.0 198.5 Q 141.1 194.9 142.0 187.5 L 142.0 168.5 Q 143.5 162.0 148.5 159.0 L 152.5 157.0 Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 4",
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 157.0 Q 199.0 156.0 200.0 159.5 L 200.5 196.0 L 212.5 196.0 Q 217.3 195.3 219.0 197.5 L 220.0 201.5 L 218.5 204.0 L 211.5 205.0 L 193.5 205.0 Q 188.9 201.6 191.0 191.5 L 191.0 159.5 L 193.5 157.0 Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 40",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 157.0 L 199.5 159.0 L 198.5 157.0 Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 41",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 159.0 L 145.5 162.0 L 147.5 159.0 Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 42",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 160.0 L 201.0 195.5 L 200.0 195.5 L 200.5 160.0 Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 43",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 161.0 L 96.5 163.0 L 97.5 161.0 Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 5",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 166.0 Q 167.7 163.8 171.0 169.5 L 170.5 188.0 Q 169.5 185.0 164.5 186.0 Q 160.5 186.5 161.0 191.5 L 163.0 195.5 L 156.5 196.0 L 152.0 192.5 L 152.0 175.5 Q 150.9 169.4 153.5 167.0 L 156.5 166.0 Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 44",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 168.0 L 103.5 170.0 L 104.5 168.0 Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 45",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 168.0 L 121.5 170.0 L 120.5 168.0 Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 46",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 171.0 L 26.0 171.5 Q 23.9 174.8 23.5 171.0 Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 47",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 171.0 L 152.0 190.5 L 151.0 190.5 L 151.5 171.0 Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 23",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 171.0 L 172.0 188.5 L 170.5 189.0 L 169.5 187.0 L 171.0 187.5 L 171.5 171.0 Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 24",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 173.0 L 124.5 175.0 L 123.5 173.0 Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 25",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 176.0 L 35.0 176.5 L 34.5 201.0 L 34.0 184.5 Q 34.6 177.8 33.5 176.0 Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 5",
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 176.0 L 63.0 178.5 L 68.5 190.0 L 75.5 177.0 L 78.5 176.0 L 83.0 179.5 L 81.5 185.0 L 77.5 193.0 L 61.5 224.0 L 58.5 225.0 L 54.0 221.5 Q 53.5 216.0 56.5 214.0 L 63.0 199.5 L 56.0 186.5 L 54.0 179.5 L 58.5 176.0 Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 26",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 14.5 178.0 L 15.0 199.5 L 14.0 199.5 L 14.5 178.0 Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 48",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 180.0 L 98.5 182.0 L 97.5 180.0 Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 49",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 180.0 L 127.5 182.0 L 126.5 180.0 Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 27",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 183.0 L 21.5 185.0 L 20.5 183.0 Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 28",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 183.0 L 27.5 185.0 L 28.5 183.0 Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 29",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 185.0 L 26.0 185.5 L 23.5 186.0 L 23.5 185.0 Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 30",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 187.0 L 101.5 189.0 L 100.5 187.0 Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 50",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 189.0 L 162.0 191.5 L 161.0 191.5 L 161.5 189.0 Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 51",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 192.0 L 104.5 194.0 L 103.5 192.0 Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 52",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 193.0 L 153.5 195.0 L 152.5 193.0 Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 31",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 193.0 L 163.5 195.0 L 162.5 193.0 Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 53",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 195.0 L 112.0 195.5 L 109.5 196.0 L 109.5 195.0 Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 54",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 195.0 L 116.0 195.5 L 113.5 196.0 L 113.5 195.0 Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 55",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 200.0 L 147.5 203.0 L 145.5 200.0 Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 56",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 13.5 203.0 L 12.5 205.0 L 13.5 203.0 Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    desc: "l 6 p 32",
    fill: "rgb(89,89,89)",
    stroke: "rgb(89,89,89)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 203.0 L 36.5 205.0 L 35.5 203.0 Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 57",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 205.0 L 115.0 205.5 L 111.5 206.0 L 111.5 205.0 Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 58",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 205.0 L 167.0 205.5 L 155.5 206.0 L 155.5 205.0 Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    desc: "l 3 p 59",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 205.0 L 216.0 205.5 L 195.5 206.0 L 195.5 205.0 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysql);
export default __webpack_public_path__ + "static/media/mysql.e3a4fe462f1e2fa8dcf9cef37f1e8624.svg";
export { ForwardRef as ReactComponent };